{
  "LABEL_MGMT": {
    "HEADER": "Labels",
    "HEADER_BTN_TXT": "Add label",
    "LOADING": "Fetching labels",
    "DESCRIPTION": "Labels help you categorize and prioritize conversations and leads. You can assign a label to a conversation or contact using the side panel.",
    "LEARN_MORE": "Learn more about labels",
    "SEARCH_404": "There are no items matching this query",
    "LIST": {
      "404": "There are no labels available in this account.",
      "TITLE": "Manage labels",
      "DESC": "Labels let you group the conversations together.",
      "TABLE_HEADER": {
        "NAME": "Name",
        "DESCRIPTION": "Description",
        "COLOR": "Color"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Label Name",
        "PLACEHOLDER": "Label name",
        "REQUIRED_ERROR": "Label name is required",
        "MINIMUM_LENGTH_ERROR": "Minimum length 2 is required",
        "VALID_ERROR": "Only Alphabets, Numbers, Hyphen and Underscore are allowed"
      },
      "DESCRIPTION": {
        "LABEL": "Description",
        "PLACEHOLDER": "Label Description"
      },
      "COLOR": {
        "LABEL": "Color"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Show label on sidebar"
      },
      "EDIT": "Edit",
      "CREATE": "Create",
      "DELETE": "Delete",
      "CANCEL": "Cancel"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Add label to conversation",
        "MULTIPLE_SUGGESTION": "Select this label",
        "DESELECT": "Deselect label",
        "DISMISS": "Dismiss suggestion"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Dismiss",
      "ADD_SELECTED_LABELS": "Add selected labels",
      "ADD_SELECTED_LABEL": "Add selected label",
      "ADD_ALL_LABELS": "Add all labels",
      "SUGGESTED_LABELS": "Suggested labels"
    },
    "ADD": {
      "TITLE": "Add label",
      "DESC": "Labels let you group the conversations together.",
      "API": {
        "SUCCESS_MESSAGE": "Label added successfully",
        "ERROR_MESSAGE": "There was an error, please try again"
      }
    },
    "EDIT": {
      "TITLE": "Edit label",
      "API": {
        "SUCCESS_MESSAGE": "Label updated successfully",
        "ERROR_MESSAGE": "There was an error, please try again"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "API": {
        "SUCCESS_MESSAGE": "Label deleted successfully",
        "ERROR_MESSAGE": "There was an error, please try again",
        "IN_USE_ERROR": "Te oznake ni mogoče izbrisati, ker je uporabljena v {usages}. Najprej jo odstranite iz teh zapisov.",
        "IN_USE_FILTERS": "filtri: {names}",
        "IN_USE_AUTOMATIONS": "pravila avtomatizacije: {names}",
        "IN_USE_MACROS": "makri: {names}"
      },
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure to delete ",
        "YES": "Yes, Delete ",
        "NO": "No, Keep "
      }
    }
  }
}
